import { useEffect } from 'react';

import type { GlobalContext } from '/imports/ui/components/GlobalContext';
import { useGlobalContextWithActions } from '/imports/ui/components/GlobalContext';

export const useSetPreferredEntry = (preferredEntry: GlobalContext['preferredEntry']) => {
  const [, dispatch] = useGlobalContextWithActions();
  useEffect(() => {
    dispatch({ preferredEntry });
  }, []);
};
